import axios from "axios";
import { HOST_URL } from "../constants/Constants";

export const getAllHelpContent = async () => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/training/getAllTrainingContent",
    withCredentials: true,
  });
  return data.data;
};
